// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyD1qdEVHubK1Zrs9AFPKNGUwW-5OUOBexE",
    authDomain: "shore-cottage-datastore.firebaseapp.com",
    projectId: "shore-cottage-datastore",
    storageBucket: "shore-cottage-datastore.appspot.com",
    messagingSenderId: "836304076155",
    appId: "1:836304076155:web:a93de67a66c03cb198d1de",
    measurementId: "G-Z23JCYG5FN"
  };